module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1039-8eb8e28ee030e93dc9f1f046ca71d62f.png";